import { Link, Typography } from "@mui/material";
import env from '../../core/config/env'

function CopyrightCeletus(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 4, mb: 4 }} {...props}>
            {"Copyright © "}
            <Link color="inherit" href={env.SITE_HOST}>
                {env.COPYRIGHT}
            </Link>{" "}
            {new Date().getFullYear()}
            {"."}
        </Typography>
    );
}

export default CopyrightCeletus;
